











import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import TinyMce from '@/components/admin/TinyMce.vue'
import Post, {IPost} from '@/models/Post'
import {apiV1AdminRecruitPath} from '@/rails/routes'
import AddinForm from '@/components/admin/recruits/AddinForm.vue'
import Recruit, {IRecruit} from '@/models/Recruit'
import AddinTags from '@/components/admin/recruits/AddinTags.vue'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    AddinTags,
    AddinForm,
    TinyMce,
    PostForm
  }
})
export default class RecruitEdit extends PostEdit {

  mounted(): Promise<void> {
    this.targetPath = apiV1AdminRecruitPath(this.$route.params.id)
    this.tagCategory = 'recruit_cat'
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Recruit(data as IRecruit)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '求人情報一覧',
        to: '/admin/recruits',
        exact: true
      },
      {
        text: '求人情報編集'
      }
    ]
  }
}
